import React from 'react';
import { CheckCircle2, AlertCircle } from 'lucide-react';

export function Status() {
    return (
        <div className="min-h-screen bg-background py-16 px-4 sm:px-6 lg:px-8">
            <div className="max-w-3xl mx-auto">
                <h1 className="text-3xl font-bold text-foreground mb-8">System Status</h1>

                <div className="bg-card border border-border rounded-lg p-6 mb-8">
                    <div className="flex items-center gap-4">
                        <div className="flex items-center justify-center w-12 h-12 rounded-full bg-green-100 dark:bg-green-900/20">
                            <CheckCircle2 className="h-6 w-6 text-green-600 dark:text-green-400" />
                        </div>
                        <div>
                            <h2 className="text-xl font-semibold text-foreground">All Systems Operational</h2>
                            <p className="text-muted-foreground">Last updated: {new Date().toLocaleTimeString()}</p>
                        </div>
                    </div>
                </div>

                <div className="space-y-4">
                    <div className="flex justify-between items-center p-4 bg-card/50 rounded-lg border border-border/50">
                        <span className="font-medium text-foreground">API</span>
                        <span className="text-green-600 dark:text-green-400 text-sm font-medium">Operational</span>
                    </div>
                    <div className="flex justify-between items-center p-4 bg-card/50 rounded-lg border border-border/50">
                        <span className="font-medium text-foreground">Background Removal Engine</span>
                        <span className="text-green-600 dark:text-green-400 text-sm font-medium">Operational</span>
                    </div>
                    <div className="flex justify-between items-center p-4 bg-card/50 rounded-lg border border-border/50">
                        <span className="font-medium text-foreground">Dashboard & Auth</span>
                        <span className="text-green-600 dark:text-green-400 text-sm font-medium">Operational</span>
                    </div>
                    <div className="flex justify-between items-center p-4 bg-card/50 rounded-lg border border-border/50">
                        <span className="font-medium text-foreground">Payments</span>
                        <span className="text-green-600 dark:text-green-400 text-sm font-medium">Operational</span>
                    </div>
                </div>
            </div>
        </div>
    );
}
